module.exports = __webpack_public_path__ + "static/media/robotDrone.696cbb2e.svg";